import React from "react";
import { useForm } from "react-hook-form";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import {
  INQUIRY_CATEGORY_LIST_QUERY,
  INQUIRY_REPLY_QUERY,
  INQUIRY_DETAIL_QUERY,
  INQUIRY_DELETE_QUERY
} from "../../Queries";
import { Button } from "reactstrap";
import { useQuery, useMutation } from "react-apollo-hooks";
import {
  Panel,
  PanelHeader,
  PanelBody
} from "../../../../../Components/Panel/Panel";
// import { InputGroup, Input, InputGroupAddon, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/pro-regular-svg-icons";

export default ({
  history,
  match,
  location,
  id,
  inquiryCategory,
  question,
  answer
}) => {
  const { data } = useQuery(INQUIRY_CATEGORY_LIST_QUERY, {
    variables: {
      inquiryConfig: match.params.inquiryConfig,
      commonApp: match.params.CommonApp
    }
  });
  const [inquiryReplyMutation] = useMutation(INQUIRY_REPLY_QUERY, {
    refetchQueries: () => [{ query: INQUIRY_DETAIL_QUERY, variables: { id } }]
  });
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {
      inquiryCategory: inquiryCategory.id,
      question: question,
      answer: answer
    }
  });
  const onSubmit = async data => {
    try {
      const {
        data: { AdminInquiryReply }
      } = await inquiryReplyMutation({
        variables: {
          id: id,
          inquiryCategory: data.inquiryCategory,
          question: data.question,
          answer: data.answer
        }
      });
      if (AdminInquiryReply) {
        toast.success("처리 되었습니다.");
        history.push(
          `/inquiryConfigs/${match.params.CommonApp}/${match.params.inquiryConfig}/inquiries/${id}${location.search}`
        );
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };
  const [inquiryDeleteMutation] = useMutation(INQUIRY_DELETE_QUERY);
  const onDelete = async id => {
    try {
      const {
        data: { AdminInquiryDelete }
      } = await inquiryDeleteMutation({
        variables: {
          id: id
        }
      });
      if (AdminInquiryDelete) {
        toast.success("처리 되었습니다.");
        history.push(
          `/inquiryConfigs/${match.params.CommonApp}/${match.params.inquiryConfig}/inquiries${location.search}`
        );
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };
  return (
    <>
      <Helmet>
        <title>1:1 문의 관리 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item active">도움말</li>
        </ol>
        <h1 className="page-header">도움말</h1>
        <form
          className="form-horizontal form-bordered"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="row m-b-15">
            <div className="col-xs-6 text-left">
              <Link
                to={`/inquiryConfigs/${match.params.CommonApp}/${match.params.inquiryConfig}/inquiries${location.search}`}
                className="btn btn-white"
              >
                <FontAwesomeIcon icon={faList} />
                목록
              </Link>
            </div>
            <div className="col-xs-6 text-right">
              <div className="btn-group">
                <button type="submit" className="btn btn-white text-blue">
                  확인
                </button>
                <Button
                  type="button"
                  color="white"
                  className="text-red"
                  onClick={() => {
                    onDelete(id);
                  }}
                >
                  삭제
                </Button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Panel>
                <PanelHeader>작성</PanelHeader>
                <PanelBody className="panel-form">
                  <div className="form-group row">
                    <label className="col-form-label col-md-2">분류</label>
                    <div className="col-md-10">
                      {data &&
                        data.AdminInquiryCategoryList.inquiryCategories.map(
                          (category, index) => {
                            return (
                              <div
                                key={index}
                                className="radio radio-css radio-inline"
                              >
                                <input
                                  key={category.id}
                                  type="radio"
                                  id={`inquiryCategory${category.id}`}
                                  name="inquiryCategory"
                                  className="form-control"
                                  value={category.id}
                                  ref={register({
                                    required: "분류를 선택해주세요."
                                  })}
                                />
                                <label
                                  htmlFor={`inquiryCategory${category.id}`}
                                >
                                  {category.name}
                                </label>
                              </div>
                            );
                          }
                        )}
                      {errors.inquiryCategory && (
                        <span>{errors.inquiryCategory.message}</span>
                      )}
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-form-label col-md-2">질문</label>
                    <div className="col-md-10">
                      <input
                        type="text"
                        name="question"
                        className="form-control m-b-5"
                        placeholder="질문을 입력해주세요."
                        ref={register({
                          required: "질문을 입력해주세요."
                        })}
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-xs-12">
                      <textarea
                        name="answer"
                        className="form-control m-b-5"
                        placeholder="답변을 입력해주세요."
                        ref={register({
                          required: "답변을 입력해주세요."
                        })}
                        rows="10"
                      ></textarea>
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6 text-left">
              <Link
                to={`/inquiryConfigs/${match.params.CommonApp}/${match.params.inquiryConfig}/inquiries${location.search}`}
                className="btn btn-white"
              >
                <FontAwesomeIcon icon={faList} />
                목록
              </Link>
            </div>
            <div className="col-xs-6 text-right">
              <div className="btn-group">
                <button type="submit" className="btn btn-white text-blue">
                  확인
                </button>
                <Button
                  type="button"
                  color="white"
                  className="text-red"
                  onClick={() => {
                    onDelete(id);
                  }}
                >
                  삭제
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
